import React, { useState } from 'react'
import { schema } from './schema'
import { Button, Dialog, TextInputField, toaster } from 'evergreen-ui'
import { handleLogout, setCompany as handleCompany } from '../../Redux/reducers/auth';
import { connect } from 'react-redux'
import IMask from 'imask';
import axios from '../../Utils/axios';

const CompanyForm = ({
  dispatch
}) => {
  const initialState = {
    cnpj: '', tradeName: '', corporateName: '', email: '', phone: ''
  }
  const [company, setCompany] = useState(initialState)

  const [errors, setErrors] = useState({})
  const phoneMask = IMask.createMask({
    mask: '+{55}(00) 0000-0000'
  })
  const cnpjMask = IMask.createMask({
    mask: '00.000.000/0000-00'
  })

  const getFields = () => {
    const { cnpj, tradeName, corporateName, email, phone } = company
    return [
      {
        name: 'cnpj',
        label: 'CNPJ',
        required: true,
        action: (value) => {
          cnpjMask.value = value
          setCompany({
            ...company,
            cnpj: cnpjMask.value
          })
        },
        value: cnpj
      },
      {
        name: 'corporateName',
        label: 'Razão Social',
        required: true,
        action: (value) => {
          setCompany({
            ...company,
            corporateName: value
          })
        },
        value: corporateName
      },
      {
        name: 'tradeName',
        label: 'Nome Fantasia',
        required: true,
        action: (value) => {
          setCompany({
            ...company,
            tradeName: value
          })
        },
        value: tradeName
      },
      {
        name: 'phone',
        label: 'Telefone',
        placeholder: '(XX) XXXXX-XXXX',
        required: true,
        action: (value) => {
          phoneMask.value = value
          setCompany({
            ...company,
            phone: phoneMask.value
          })
        },
        value: phone,
      },
      {
        name: 'email',
        label: 'E-mail',
        placeholder: 'email@email.com.br',
        required: true,
        action: (value) => {
          setCompany({
            ...company,
            email: value
          })
        },
        value: email
      }
    ]
  }

  const createCompany = async (company) => {
    try {
      const { data } = await axios.post('/companies', company)
      dispatch(handleCompany(data))
      toaster.success('Empresa cadastrada com sucesso')
    }
    catch (error) {
      toaster.danger(error.response.data.error.message)
    }
    finally {
    }
  }

  const validateFields = (e) => {
    e.preventDefault()
    const { cnpj, tradeName, corporateName, email, phone } = company
    toaster.closeAll()
    schema.validate({
      cnpj: cnpj.replace(/[^\w\s]/gi, ''), tradeName, corporateName, email, phone
    }, {
        abortEarly: false,
        recursive: true
      })
      .then((done) => {
        setErrors({})

        if (done.phone.length < 16) {
          setErrors({
            phone: 'Finalize o telefone'
          })
          return toaster.danger('Termine de preencher o telefone')
        }

        createCompany(done)
      }).catch(({ inner }) => {
        let error = {}
        inner.map(err => {
          return error = {
            ...error,
            [err.path]: err.message
          }
        })
        setErrors(error)
        return toaster.danger('Erro ao cadastrar empresa')
      })
  }

  const logout = () => dispatch(handleLogout())

  return (
    <Dialog
      isShown={true}
      hasFooter={false}
      shouldCloseOnOverlayClick={false}
      onCloseComplete={() => logout()}
    >
      <form onSubmit={validateFields}>
        {getFields().map(item =>
          <TextInputField
            key={item.name}
            label={item.label}
            id={item.name}
            required={item.required}
            isInvalid={!!errors[item.name]}
            validationMessage={errors[item.name]}
            placeholder={item.placeholder ? item.placeholder : item.label}
            type="text"
            value={item.value}
            onChange={({ target }) => item.action(target.value)}
            description=""
          />
        )}

        <Button
          type='submit'
          marginLeft={16} appearance='primary'
          onClick={validateFields}>
          Cadastrar
      </Button>
      </form>
    </Dialog >
  )

}

export default connect()(CompanyForm)